import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { MyCustomSelect } from 'components/common';
import { probabilityOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Probability = () => {
    const { setValue, control } = useFormContext<Risk>();

    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Probability:</div>
            <div data-testid={'probability'} className={classes.content}>
                <Controller
                    render={({ field }) => (
                        <MyCustomSelect<ISelectOption<Risk['probability']>>
                            {...field}
                            value={probabilityOptions.find((option) => option.value === field.value)}
                            onChange={(value) => value && setValue('probability', value.value, { shouldDirty: true })}
                            options={probabilityOptions}
                            placeholder="Select probability"
                            isClearable={false}
                        />
                    )}
                    name="probability"
                    control={control}
                />
            </div>
        </div>
    );
};
